import * as THREE from 'three/webgpu';
import { VEC3 } from './util';

export default class Machine {
    scene!: THREE.Scene;
    mesh!: THREE.Object3D;

    speed: number = 0;
    acceleration: number = 0;
    progress: number = 0;

    constructor(scene: THREE.Scene) {
        this.scene = scene;
    }

    public getLength() {
        const box = new THREE.Box3().setFromObject(this.mesh);
        box.getSize(VEC3);
        return VEC3.z || 1;
    }
}
